import { styled } from '@mui/material/styles';
import { Card, Box, Typography, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const PromptCardContainer = styled(Card)(({ theme }) => ({
  display: 'flex',
  width: '393px',
  height: '310px',
  margin: 'auto',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'rgba(0, 0, 0, 0.5)',
  backdropFilter: 'blur(2px)',
  borderRadius: '0',
  [theme.breakpoints.down('400')]: {
    width: '363px',
    height: '310px',
  },
}));

const PromptContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '373px',
  height: '290px',
  padding: '40px',
  margin: 'auto',
  border: '1px solid #AA9178',
  gap: '25px',
  [theme.breakpoints.down('400')]: {
    width: '343px',
    height: '290px',
  },
}));

const PromptTitle = styled(Typography)({
  display: 'flex',
  fontFamily: 'Fjalla One',
  fontWeight: 400,
  fontSize: '20px',
  lineHeight: '25px',
  alignItems: 'center',
  color: '#FFFFFF',
  gap: '10px',
});
const Promptdetails = styled(Typography)({
  fontFamily: 'Raleway',
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '18px',
  color: '#FFFFFF',
});

const PromptButton = styled(Button)({
  width: '92px',
  height: '27px',
  backgroundColor: '#AA9178',
  borderRadius: 0,
});

const DirectHome = styled('a')({
  display: 'flex',
  fontFamily: 'Fjalla One',
  fontWeight: 400,
  fontSize: '14px',
  color: '#FFFFFF',
  textDecoration: 'none',
  alignItems: 'center',
});

const PromptCard = () => {
  return (
    <PromptCardContainer>
      <PromptContent>
        <PromptTitle>
          <CloseIcon />
          404 We can't find the page
        </PromptTitle>
        <Promptdetails>
          The page you are looking for could have been removed, had its name changed, or is
          temporarily unavailable. Please review the URL and make sure that it is spelled correctly.
        </Promptdetails>
        <PromptButton>
          <DirectHome href="/">Return Home</DirectHome>
        </PromptButton>
      </PromptContent>
    </PromptCardContainer>
  );
};

export default PromptCard;
